import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { getStartDateForSchoolYear } from 'Src/helpers/calendar/calendar';
import { getDefaultReportAgesForMultiSelect, getReportDefaultGendersForMultiSelect } from 'Src/helpers/multiselect/multiselect';
import { UnionSchoolReportForm } from '../UnionSchoolReportForm';

interface Props { onCloseClick: () => void; onSubmit: (data: any, reportType: string) => void; }
export function UnionSchoolFixturesReportForm({ onCloseClick, onSubmit }: Props) {
  const now = new Date();
  return <UnionSchoolReportForm
    initialValues={{ dateFrom: getStartDateForSchoolYear(now), dateTo: now, ageGroups: getDefaultReportAgesForMultiSelect(), genders: getReportDefaultGendersForMultiSelect(), isShowBlank: true, isGroupBySports: true, isSelectAllAges: true }}
    reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.UNION_SCHOOL_FIXTURES}
    description="Summarise sports events organised by schools across the union for the selected period and audience."
    toggles={[
      { field: 'isShowBlank', label: 'Include schools with no events', hint: 'Keep schools with no matching sports events in the report.' },
      { field: 'isGroupBySports', label: 'Group by sport or activity', hint: 'Show detailed statistics grouped by sport instead of one aggregated total.' }
    ]}
    onCloseClick={onCloseClick} onSubmit={onSubmit}
  />;
}
